import { TileAbstractDisplay } from './TileAbstractDisplay.js';
import { useHiveRenderingMetadata } from '../../../hooks/use-hive-rendering-metadata.js';

export const HiveDisplay = () => {
  const { tileData } = useHiveRenderingMetadata();

  return (
    <>
      {tileData.map((data, index) => {
        return <TileAbstractDisplay data={data} key={index} />;
      })}
    </>
  );
};

HiveDisplay['displayName'] = 'HiveDisplay';
